var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRendericon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_126_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.586 3.33707e-05V3.17203H7.523C6.38902 3.2135 5.31194 3.67924 4.505 4.47703C3.70088 5.27089 3.225 6.33831 3.172 7.46703V18.793H2.44079e-06V7.50903C-0.000794436 6.5231 0.193541 5.54675 0.57181 4.63626C0.950078 3.72577 1.5048 2.89915 2.204 2.20403C2.88642 1.5162 3.69613 0.967681 4.588 0.589033C5.51223 0.197388 6.50622 -0.00297453 7.51 3.33707e-05H13.586ZM18.793 3.33707e-05V3.15803H15.62V3.33707e-05H18.793ZM24 3.33707e-05V3.15803H20.828V3.33707e-05H24ZM24 5.20703V8.37903H20.828V5.20703H24ZM24 10.414V13.586H20.828V10.414H24ZM24 15.621V18.793H20.828V15.62L24 15.621ZM24 20.828V24H20.828V20.828H24ZM18.793 20.828V24H15.62V20.828H18.793ZM13.586 20.828V24H10.414V20.828H13.586ZM8.379 20.828V24H5.207V20.828H8.379ZM3.158 20.828V24H2.44079e-06V20.828H3.158Z",
    fill: "#5EEBC4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_126_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRendericon);
export default __webpack_public_path__ + "static/media/rendericon.992541da08e1ca4e829a2d15f8ce41f7.svg";
export { ForwardRef as ReactComponent };